/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Car'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('car'); // main translation loaded for car
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('document'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity
		$translatePartialLoader.addPart('carrentaltype'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/car/car-dialog.html';

		return {
			/* new state for entity car */
			/* to access: ui-ref="car.list.new" */
			/* url: hostname/car/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CarDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CarFactory',
									'NewCarFactory',
									function(CarFactory, NewCarFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Car
										// - resuming the creation of a new new Car AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return CarFactory.get({ id: $stateParams.carId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewCarFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for car new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for car edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('car', {
		/* abstract state for entity car */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/car',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Cars',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('car.list', {
		/* list state for entity car */
		/* to access: ui-ref="car.list" */
		/* url: hostname/car/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/car/cars.html',
				controller: 'CarController',
			},
		},
	});

	$stateProvider.state('car.detail', {
		/* detail state for entity car */
		/* to access: ui-sref="car.detail" */
		/* url: hostname/car/detail/:carId */
		url: '/detail/:carId',
		views: {
			'content@': {
				templateUrl: 'app/entities/car/car-detail.html',
				controller: 'CarDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CarFactory',
				function($stateParams, CarFactory) {
					return CarFactory.get({ id: $stateParams.carId });
				},
			],
		},
	});

	/* url: http://<hostname>/car/list/new */
	$stateProvider.state('car.list.new', getNewState());
	/* url: http://<hostname>/car/list/:carId/edit */
	$stateProvider.state('car.list.edit', getEditState('/:carId/edit'));
	/* url: http://<hostname>/car/detail/:carId/edit */
	$stateProvider.state('car.detail.edit', getEditState('/edit'));
	// Relation.car with multiplicity 0..n points to Car
	/* url: http://<hostname>/relation/detail/:relationId/car/new */
	$stateProvider.state('relation.detail.newCar', getNewState('/car/new'));
	/* url: http://<hostname>/relation/detail/:relationId/car/:carId/edit */
	$stateProvider.state('relation.detail.editCar', getEditState('/car/:carId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/car/new */
	$stateProvider.state('user-relation.detail.newCar', getNewState('/car/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/car/:carId/edit */
	$stateProvider.state('user-relation.detail.editCar', getEditState('/car/:carId/edit'));
	// CarRentalType.cars with multiplicity 0..n points to Car
	/* url: http://<hostname>/carrentaltype/detail/:carRentalTypeId/car/new */
	$stateProvider.state('carrentaltype.detail.newCar', getNewState('/car/new'));
	/* url: http://<hostname>/carrentaltype/detail/:carRentalTypeId/car/:carId/edit */
	$stateProvider.state('carrentaltype.detail.editCar', getEditState('/car/:carId/edit'));

	$stateProvider.state('subscription.list.newCar', getNewState('/car/new'));
	$stateProvider.state('document.list.newCar', getNewState('/car/new'));

	$stateProvider.state('event.detail.booking.newCar', getNewState('/car/new'));
});
